import React, {useEffect, useState} from 'react';
import http from "../framework/http";
import {
    Button,
    Checkbox,
    Divider,
    Form,
    Input,
    Space,
    Table,
    Image,
    message,
    Modal,
    TreeSelect,
    Upload,
    Card, InputNumber
} from "antd";
import {CloseOutlined, DeleteOutlined, LoadingOutlined, PlusOutlined} from "@ant-design/icons";
import ReactQuill from "react-quill";

function ModelManagement() {
    const [models, setModels] = useState();
    const [categorySelectionTree, setCategorySelectionTree] = useState();
    const [searchForm] = Form.useForm();
    const [searchButtonLoading, setSearchButtonLoading] = useState();
    const [submitMethod, setSubmitMethod] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteButtonLoading, setDeleteButtonLoading] = useState(new Map());
    const [editButtonLoading, setEditButtonLoading] = useState(new Map());
    const [form] = Form.useForm();
    const [modalConfirmLoading, setModalConfirmLoading] = useState();
    const [uploading, setUploading] = useState();

    useEffect(() => {
        loadModel();
        loadCategorySelectionTree();
    }, []);

    const loadModel = async (params) => {
        const res = await http.get("/model/list", {params: params});
        if (res.data && res.data.code === 200) {
            setModels(res.data.data);
        }
    };

    const buildCategoryTree = (categoryMeta, parentId = 0) => {
        const categorySelectionTree = [];
        for (const item of categoryMeta) {
            if (item.parentId === parentId) {
                let categorySelectionTreeNode = {title: item.name, value: item.id};
                const children = buildCategoryTree(categoryMeta, item.id);
                if (children.length > 0) {
                    categorySelectionTreeNode.children = children;
                    categorySelectionTreeNode.selectable = false;
                }
                categorySelectionTree.push(categorySelectionTreeNode);
            }
        }
        return categorySelectionTree;
    };

    const loadCategorySelectionTree = async () => {
        const res = await http.get("/category/list");
        if (res.data && res.data.code === 200) {
            setCategorySelectionTree([{
                title: "root",
                value: 0,
                selectable: false,
                children: buildCategoryTree(res.data.data)
            }]);
        }
    };

    const submitForm = async (formData) => {
        if (uploading) {
            message.warning("upload haven't finish, try again later");
        } else {
            setModalConfirmLoading(true);

            // process data
            formData.cover = formData.cover?.url;
            formData.options.map(option => {
                option.picture = option.picture?.url;
            })
            formData.keyword = formData.keyword?.replace(/\s+/g, '');

            if (submitMethod === "insert") {
                await insertModel(formData)
            } else if (submitMethod === "update") {
                await updateModel(formData);
            }

            setModalConfirmLoading(false);
        }
    };

    const insertModel = async (formData) => {
        console.log(formData)
        const res = await http.post("/model", formData);
        if (res.data?.code === 200) {
            setModels([{
                id: res.data.data,
                title: formData.title,
                cover: formData.cover,
                order: formData.order,
            }, ...models]);
            setModalOpen(false);
            form.resetFields();
            form.resetFields(["options"]);
            message.success("New record added");
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }
    };

    const updateModel = async (formData) => {
        const res = await http.put("/model", formData);
        if (res.data?.code === 200) {
            setModels(models.map(item => {
                if (item.id === formData.id) {
                    return {
                        id: formData.id,
                        title: formData.title,
                        cover: formData.cover,
                        order: formData.order,
                    }
                } else {
                    return item;
                }
            }));

            setModalOpen(false);
            form.resetFields();
            form.resetFields(["options"]);
            message.success("Record updated");
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }
    };

    const onDeleteClick = async (id) => {
        let newDeleteButtonLoading = new Map(deleteButtonLoading);
        newDeleteButtonLoading.set(id, true);
        setDeleteButtonLoading(newDeleteButtonLoading);

        const res = await http.delete("/model/" + id);
        if (res.data?.code === 200) {
            setModels(models.filter(o => o.id !== id));
            message.success("Record deleted!");
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }

        newDeleteButtonLoading = new Map(newDeleteButtonLoading);
        newDeleteButtonLoading.delete(id);
        setDeleteButtonLoading(newDeleteButtonLoading);
    };

    const onEditClick = async (id) => {
        let newEditButtonLoading = new Map(editButtonLoading);
        newEditButtonLoading.set(id, true);
        setEditButtonLoading(newEditButtonLoading);

        const res = await http.get("/model/" + id);
        if (res.data?.code === 200) {
            const model = res.data.data;
            if (model.cover) {
                model.cover = {status: 'done', name: model.cover, url: model.cover}
            }
            model.options.map(option => {
                if (option.picture) {
                    option.picture = {status: 'done', name: option.picture, url: option.picture}
                }
            })
            form.setFieldsValue(model);
            await setSubmitMethod("update");
            setModalOpen(true);

        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }

        newEditButtonLoading = new Map(newEditButtonLoading);
        newEditButtonLoading.delete(id);
        setEditButtonLoading(newEditButtonLoading);
    };

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJpgOrPng) {
            message.error('Only JPG/PNG file is accepted');
            return Upload.LIST_IGNORE;
        } else {
            if (!isLt2M) {
                message.error('Image must smaller than 2MB');
                return Upload.LIST_IGNORE;
            }
        }
        return true;
    };

    return (
        <div>
            <Form form={searchForm} onFinish={async (formData) => {
                setSearchButtonLoading(true);
                await loadModel(formData);
                setSearchButtonLoading(false);
            }} style={{marginLeft: 10}}
            >
                <Button type="primary" onClick={async () => {
                    loadCategorySelectionTree();
                    await setSubmitMethod("insert");
                    setModalOpen(true);
                }}>Add</Button>
                <Divider type="vertical"/>
                <Space>
                    <Form.Item name="keyword" label="Keyword">
                        <Input allowClear placeholder="Search by Title or ID"/>
                    </Form.Item>
                    <Form.Item
                        name="unlisted"
                        valuePropName="checked"
                    >
                        <Checkbox>Unlisted</Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={searchButtonLoading}>
                            Search
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button onClick={() => {
                            searchForm.resetFields();
                            loadModel();
                        }}>Reset</Button>
                    </Form.Item>
                </Space>
            </Form>
            <Table dataSource={models} rowKey="id" pagination={{hideOnSinglePage: true}}>
                {/*<Table.Column title="ID" dataIndex="id" width="20%"/>*/}
                <Table.Column title="Title" dataIndex="title" width="35%"/>
                <Table.Column title="Cover" dataIndex="cover" width="10%"
                              render={(src) => (src ?
                                  <Image width={50} height={50} src={http.getUri() + src}/> :
                                  <Image width={50} height={50} src={http.getUri() + "images/default.png"}/>)}/>
                <Table.Column title="Order" dataIndex="order"/>
                <Table.Column title="Operation" width="15%"
                              render={(_, record, index) => (
                                  <Space>
                                      <Button danger
                                              type="primary"
                                              loading={deleteButtonLoading.get(record.id)}
                                              onClick={() => {
                                                  onDeleteClick(record.id);
                                              }}
                                      >Delete</Button>
                                      <Button type="primary"
                                              loading={editButtonLoading.get(record.id)}
                                              onClick={() => {
                                                  loadCategorySelectionTree();
                                                  onEditClick(record.id);
                                              }}
                                      >Edit</Button>
                                  </Space>
                              )}
                />
            </Table>
            <Modal forceRender maskClosable={false} open={modalOpen}
                   confirmLoading={modalConfirmLoading} okText="Save"
                   onOk={() => {
                       form.submit()
                   }}
                   onCancel={() => {
                       setModalOpen(false);
                       form.resetFields();
                       // The form data left by the disappeared component cannot be cleared by resetting all with resetFields()
                       form.resetFields(["options"]);
                   }}
            >
                <Form form={form} labelWrap style={{marginTop: 30}} onFinish={submitForm}>
                    <Form.Item hidden={true} label="Id" name="id">
                        <Input/>
                    </Form.Item>
                    <Form.Item label="Category" name="categories">
                        <TreeSelect multiple
                                    treeLine={true}
                                    showSearch
                                    treeNodeFilterProp="title"
                                    allowClear
                                    placeholder="Please select"
                                    treeData={categorySelectionTree}/>
                    </Form.Item>
                    <Form.Item label="Title" name="title"
                               rules={[{required: true, message: 'This field can not be empty',},]}>
                        <Input/>
                    </Form.Item>
                    {/*register field first, otherwise setFieldValue() won't work*/}
                    <Form.Item name="cover" hidden/>
                    <Form.Item
                        label="Cover"
                        shouldUpdate
                    >
                        {() => {
                            return <Upload
                                listType="picture-card"
                                maxCount={1}
                                accept=".jpg, .jpeg, .png"
                                showUploadList={false}
                                action={http.getUri() + "upload"}
                                name="pictureFile" // parameter name
                                data={{foldName: "model"}}
                                headers={{token: window.localStorage.getItem("token")}}
                                beforeUpload={beforeUpload}
                                onChange={(info) => {
                                    console.log(info)
                                    if (info.file.status === 'uploading') {
                                        setUploading(true);
                                        return;
                                    }
                                    if (info.file.status === 'done') {
                                        setUploading(false);
                                        const file = info.file;
                                        file.url = info.file.response.data.path;
                                        form.setFieldValue("cover", file)
                                    }
                                }}
                            >
                                {form.getFieldValue("cover")?.url ? (
                                    <div style={{position: "relative", width: '100%', height: "100%"}}>
                                        <img src={http.getUri() + form.getFieldValue("cover").url}
                                             style={{width: '100%', height: "100%", borderRadius: "8%"}} alt=""/>
                                        <DeleteOutlined
                                            style={{
                                                position: "absolute",
                                                left: "110%",
                                                top: "50%",
                                                transform: "translate(0%,-50%)"
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                form.resetFields(["cover"]);
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div>
                                        {form.getFieldValue("cover")?.status === "uploading" ? <LoadingOutlined/> :
                                            <PlusOutlined/>}
                                        <div style={{marginTop: 8,}}>Upload</div>
                                    </div>
                                )}
                            </Upload>
                        }}
                    </Form.Item>
                    <Form.Item
                        label="Order"
                        name="order"
                        initialValue={0}
                        rules={[
                            {
                                required: true,
                                message: 'Order field can not be empty',
                            }
                        ]}
                    >
                        <InputNumber style={{width: '100%',}} min={0} precision={0}/>
                    </Form.Item>
                    <Form.Item label="Keywords" name="keyword">
                        <Input.TextArea/>
                    </Form.Item>
                    <Form.Item
                        label="Description"
                        name="description"
                    >
                        <ReactQuill
                            theme="snow"
                        />
                    </Form.Item>
                    <Divider>Model Options</Divider>
                    <Form.List name="options" rules={[
                        {
                            validator: async (_, value) => {
                                if (!value || value.length < 1) {
                                    return Promise.reject(new Error('At least one option'));
                                }
                            },
                        }
                    ]}>
                        {(fields, {add, remove}, {errors}) => <>
                            <Space direction="vertical" style={{width: "100%"}}>
                                {fields.map(({key, name, ...restField}) =>
                                    <Card key={key} bodyStyle={{paddingBottom: 5, paddingTop: 30}} hoverable
                                          bordered={false}>
                                        <CloseOutlined
                                            style={{position: "absolute", right: 10, top: 10}}
                                            onClick={() => {
                                                remove(name);
                                            }}
                                        />
                                        <Form.Item {...restField} label="Option Id" name={[name, "id"]} hidden>
                                            <Input/>
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            label="Name"
                                            name={[name, "name"]}
                                            rules={[{required: true, message: 'This field can not be empty',},]}
                                        >
                                            <Input/>
                                        </Form.Item>
                                        <Form.Item name={[name, "picture"]} hidden/>
                                        <Form.Item {...restField}
                                                   label="Picture"
                                                   shouldUpdate
                                        >
                                            {() => {
                                                return <Upload
                                                    listType="picture-card"
                                                    maxCount={1}
                                                    accept=".jpg, .jpeg, .png"
                                                    showUploadList={false}
                                                    action={http.getUri() + "upload"}
                                                    name="pictureFile" // parameter name
                                                    data={{foldName: "model"}}
                                                    headers={{token: window.localStorage.getItem("token")}}
                                                    beforeUpload={beforeUpload}
                                                    onChange={(info) => {
                                                        console.log(info)
                                                        if (info.file.status === 'uploading') {
                                                            setUploading(true);
                                                            return;
                                                        }
                                                        if (info.file.status === 'done') {
                                                            setUploading(false);
                                                            const file = info.file;
                                                            file.url = info.file.response.data.path;
                                                            form.setFieldValue(["options", name, "picture"], file)
                                                        }
                                                    }}
                                                >
                                                    {form.getFieldValue(["options", name, "picture"])?.url ? (
                                                        <div style={{
                                                            position: "relative",
                                                            width: '100%',
                                                            height: "100%"
                                                        }}>
                                                            <img
                                                                src={http.getUri() + form.getFieldValue(["options", name, "picture"]).url}
                                                                style={{
                                                                    width: '100%',
                                                                    height: "100%",
                                                                    borderRadius: "8%"
                                                                }} alt=""/>
                                                            <DeleteOutlined
                                                                style={{
                                                                    position: "absolute",
                                                                    left: "110%",
                                                                    top: "50%",
                                                                    transform: "translate(0%,-50%)"
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    form.resetFields([["options", name, "picture"]]);
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {form.getFieldValue(["options", name, "picture"])?.status === "uploading" ?
                                                                <LoadingOutlined/> :
                                                                <PlusOutlined/>}
                                                            <div style={{marginTop: 8,}}>Upload</div>
                                                        </div>
                                                    )}
                                                </Upload>
                                            }}
                                        </Form.Item>
                                        <Form.Item {...restField} label="Price" name={[name, "price"]}
                                                   rules={[{
                                                       required: true,
                                                       message: 'This field can not be empty'
                                                   }, {pattern: /^\d+(\.\d{1,2})?$/, message: "Invalid price"}]}>
                                            <Input/>
                                        </Form.Item>
                                    </Card>
                                )}
                            </Space>
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{width: '60%', marginTop: 12}}
                                    icon={<PlusOutlined/>}
                                >
                                    Add option
                                </Button>
                                <Form.ErrorList errors={errors}/>
                            </Form.Item>
                        </>}
                    </Form.List>
                </Form>
            </Modal>
        </div>
    );
}

export default ModelManagement;
